'use client'

import { useTopNavIntersection } from 'hooks'

import { VideoOverlay } from 'components/ui'


type ContentProps = {}

const Content: React.CFC<ContentProps> = (props) => {
  const { children } = props

  // const [ ref ] = useTopNavIntersection()

  return (
    <div className="relative -mt-16 pb-16 sm:pb-20 z-0 flex flex-col rounded-t-8 sm:rounded-t-16 overflow-hidden">
      <VideoOverlay className="absolute top-0 left-0 size-full -z-10 -scale-y-100" />
      <div className="absolute top-0 left-0 size-full -z-10 bg-deep-blue/70" />
      <div className="absolute top-0 left-0 size-full -z-10 bg-dots-blue-25 bg-size-5 bg-top mask-gradient-to-t to-black to-95%" />
      <div className="absolute bottom-0 left-0 w-full h-1/4 -z-10 bg-gradient-to-t from-deep-blue2" />
      <div className="pt-12 px-5 sm:px-3vw xl:px-0 text-white">
        {children}
      </div>
    </div>
  )
}

export default Content
